import { isMobileOrTablet } from '../app-utils/mobile-utils';
import { getMetaContentByName } from './helper';

/** Function to add bottom margin to product pages */
export const handleProductPages = () => {
  const caStoredPlacement = localStorage.getItem('caBottomPlacement');
  const caButton = document.getElementById('caHelpButton');
  const pageName = getMetaContentByName('pageName');

  if (
    pageName &&
    pageName?.toLowerCase().includes('product page') &&
    isMobileOrTablet() &&
    caStoredPlacement &&
    caButton != null &&
    caButton.classList.contains('caHelpButtonEnabled')
  ) {
    console.info('caStoredPlacement ---> ', caStoredPlacement);
    caButton.style.marginBottom = caStoredPlacement;
    localStorage.removeItem('caBottomPlacement');
  }
};
